<template>
    <form v-if="status.detail" @submit.prevent="submitForm">
        <b-form-group :label="$t('label.name')" label-cols="3" label-align="left">
            <b-form-input v-model.trim="form.name" :state="fieldState('name')" />
            <b-form-invalid-feedback>{{ $t('message.requiredX', [$t('label.name')]) }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group :label="$t('label.description')" label-cols="3" label-align="left">
            <b-form-textarea v-model.trim="form.description" rows="4" :state="fieldState('description')" />
            <b-form-invalid-feedback>{{ $t('message.requiredX', [$t('label.description')]) }}</b-form-invalid-feedback>
        </b-form-group>
        <hr class="my-3 mx-n3">
        <div class="d-flex justify-content-end">
            <b-button type="button" variant="danger" class="mr-2" @click="$emit('done')">{{ $t('label.cancel') }}</b-button>
            <b-button type="submit" variant="info" :disabled="!status.save">
                <span v-if="status.save">{{ $t(categoryUUID ? 'label.updateX' : 'label.createX', [$t('module.documentCategory')]) }}</span>
                <b-spinner v-else small />
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center p-5"><b-spinner variant="info" /></div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { documentCategoryMethods } from '@/state/api';
import { DOCUMENT_CATEGORY_MODULE } from '@/state/api/documentCategory.state';

export default {
    name: 'DocumentCategoryForm',
    props: { categoryUUID: { type: String, default: '' }, searchCriteria: { type: Object, required: true } },
    data() { return { submitted: false, form: { uuid: '', name: '', description: '' } }; },
    validations: { form: { name: { required }, description: { required } } },
    computed: {
        ...mapState(DOCUMENT_CATEGORY_MODULE, ['status']),
        details() { return this.$store.state.api.documentCategory.details || {}; },
    },
    created() { this.loadCategory(); },
    methods: {
        ...documentCategoryMethods,
        fieldState(field) { return this.submitted ? !this.$v.form[field].$invalid : null; },
        async loadCategory() {
            if (!this.categoryUUID) return;
            const result = await this.getDocumentCategory({ uuid: this.categoryUUID });
            if (result) this.form = { ...this.form, ...this.details };
        },
        async submitForm() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) return;
            const action = this.categoryUUID ? this.updateDocumentCategory : this.createDocumentCategory;
            const result = await action({ data: this.form, filter: this.searchCriteria });
            if (result?.success) this.$emit('done');
        },
    },
};
</script>
